import { useMemo } from 'react'

export function useOperatingSystem() {
  return useMemo(getOS, [])
}

function getOS() {
  const userAgent = window.navigator.userAgent
  const platform = window.navigator.platform

  // Windows
  if (/Windows/.test(userAgent)) return 'Windows'

  // macOS
  if (/Mac OS X (\d+[._]\d+)/.test(userAgent)) {
    return 'macOS'
  }

  // iOS
  if (/iPhone|iPad|iPod/.test(userAgent)) {
    return 'iOS'
  }

  // Android
  if (/Android/.test(userAgent)) {
    return 'Android'
  }

  // Linux
  if (/Linux/.test(platform)) return 'Linux'

  return null
}
